import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { TagAssignmentState } from '../models/search-filters.model';
import * as selectors from '../selectors/tag-assignment.selectors';

@Injectable({ providedIn: 'root' })
export class TagAssignmentFacadeService extends FacadeService {
  constructor(public override store: Store<TagAssignmentState>) {
    super(store);
  }

  panelExpanded$ = this.storeSelect(selectors.getPanelExpansion);
  tagType$ = this.storeSelect(selectors.getTagType);
  tagTypeSelectionValues$ = this.storeSelect(selectors.getTagTypeSelectionValues);
  brandCode$ = this.storeSelect(selectors.getBrandCode);
  searchButtonDisabled$ = this.storeSelect(selectors.getSearchButtonDisabled);

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get tagType() {
    return this.storeSnapshot(this.tagType$);
  }

  get brandCode() {
    return this.storeSnapshot(this.brandCode$);
  }

  get tagTypeSelectionValues() {
    return this.storeSnapshot(this.tagTypeSelectionValues$);
  }
}
